module.exports = __webpack_public_path__ + "static/quotes-d69bb214f9b3384e045502a54f6c6e56.mp4";